import { FC, useEffect, useMemo, useState } from "react";
import { useAppContext } from "../../../../../../context/app.context";
import StatusLegendComponent from "../../../../../../common/components/status-legend/status-legend.component";
import billingsTaxiOrderListingHelper from "../billings-taxi-order-listing.helper";
import useAbort from "../../../../../../common/hooks/use-abort";
import useMetaBillingsCargoTaxiStatusCounters from "../../../../../../common/services/meta/billings/cargo-taxi/status-counters/use-meta-billings-cargo-taxi-status-counters";
import MetaBillingsCargoTaxiStatusCountersParams from "../../../../../../common/services/meta/billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters-params";
import MetaBillingsCargoTaxiStatusCounters from "../../../../../../common/services/meta/billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters";
import BillingsTaxiOrderListingItemBillingStatus from "../types/billings-taxi-order-listing-item-billing-status";

type BillingsTaxiOrderListingStatusLegendProps = {
  taxiCorporationUuid: string | null;
  visibleStatuses?: BillingsTaxiOrderListingItemBillingStatus[];
};

const BillingsTaxiOrderListingStatusLegendComponent: FC<
  BillingsTaxiOrderListingStatusLegendProps
> = (props) => {
  const [countersResponse, setCountersResponse] = useState<
    MetaBillingsCargoTaxiStatusCounters | undefined
  >();

  useAppContext();

  const metaBillingsCargoTaxiStatusCounters =
    useMetaBillingsCargoTaxiStatusCounters();
  const metaBillingsCargoTaxiStatusCountersAbort = useAbort();

  useEffect(() => {
    const params: MetaBillingsCargoTaxiStatusCountersParams = {
      taxiCorporationId: props.taxiCorporationUuid!,
    };

    metaBillingsCargoTaxiStatusCounters.load(
      params,
      metaBillingsCargoTaxiStatusCountersAbort.signal,
    );

    return metaBillingsCargoTaxiStatusCountersAbort.revoke;
  }, [props.taxiCorporationUuid]);

  useEffect(() => {
    if (!metaBillingsCargoTaxiStatusCounters.data) {
      return;
    }
    setCountersResponse(metaBillingsCargoTaxiStatusCounters.data);
  }, [metaBillingsCargoTaxiStatusCounters.data]);

  const statusOptions = useMemo(() => {
    if (!props.visibleStatuses || props.visibleStatuses.length === 0) {
      return [];
    }

    let options =
      billingsTaxiOrderListingHelper.getBillingStatusOptions(countersResponse);

    options = options.filter((option) =>
      props.visibleStatuses!.includes(option.status),
    );

    return options;
  }, [countersResponse, props.visibleStatuses]);

  return <StatusLegendComponent statusData={statusOptions} />;
};

export default BillingsTaxiOrderListingStatusLegendComponent;
